export default __webpack_public_path__ + "static/media/separator.0fe635fa.svg";